(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-archive-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    const main = document.querySelector('.template-index #MainContent');
    if (!main || main.dataset.sdMotionReady === 'true') return;

    main.dataset.sdMotionReady = 'true';
    document.documentElement.classList.add('sd-motion-ready');

    const syncDesktopViewportHeight = () => {
      if (window.matchMedia('(min-width: 768px)').matches) {
        document.documentElement.style.setProperty('--sd-live-viewport-height', `${window.innerHeight}px`);
      } else {
        document.documentElement.style.removeProperty('--sd-live-viewport-height');
      }
    };

    syncDesktopViewportHeight();
    window.addEventListener('resize', syncDesktopViewportHeight, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncDesktopViewportHeight, { passive: true });
    }

    const hero = main.querySelector('.home-banner');
    const heroSection = hero ? hero.closest('.shopify-section') : null;
    if (heroSection) heroSection.classList.add('sd-hero-section');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = [...main.querySelectorAll('[data-sd-reveal]')];

    let directoryScrollFrame = null;
    const directoryLinks = [...main.querySelectorAll('.home-archive-directory__links a[href^="#"]')];

    directoryLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const hash = new URL(link.href, window.location.href).hash;
        const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
        if (!target) return;

        event.preventDefault();

        if (window.matchMedia('(hover: none), (pointer: coarse)').matches) {
          link.classList.add('is-pressed');
          window.setTimeout(() => {
            link.classList.remove('is-pressed');
            link.blur();
          }, 180);
        }

        const startPosition = window.scrollY;
        const announcementHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')) || 0;
        const targetPosition = Math.max(0, startPosition + target.getBoundingClientRect().top - announcementHeight);
        const distance = targetPosition - startPosition;

        if (directoryScrollFrame) window.cancelAnimationFrame(directoryScrollFrame);
        window.history.pushState(null, '', hash);

        if (reducedMotion) {
          window.scrollTo(0, targetPosition);
          return;
        }

        const duration = Math.min(560, Math.max(360, Math.abs(distance) * 0.12));
        let startTime = null;

        const scrollStep = (timestamp) => {
          if (startTime === null) startTime = timestamp;
          const progress = Math.min(1, (timestamp - startTime) / duration);
          const easedProgress = 1 - Math.pow(1 - progress, 3);
          window.scrollTo(0, startPosition + distance * easedProgress);

          if (progress < 1) {
            directoryScrollFrame = window.requestAnimationFrame(scrollStep);
          } else {
            directoryScrollFrame = null;
          }
        };

        directoryScrollFrame = window.requestAnimationFrame(scrollStep);
      });
    });

    if (reducedMotion || !('IntersectionObserver' in window)) {
      reveals.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });

    reveals.forEach((element) => observer.observe(element));

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-core-story"] && !Shopify.designMode) return;
  try {
    
  function initializeCoreProgress(root) {
    root.querySelectorAll('.sd-core-story:not([data-core-progress-ready])').forEach((section) => {
      const rail = section.querySelector('.sd-core-story__products');
      const progress = section.querySelector('[data-core-story-progressbar]');
      const fill = section.querySelector('[data-core-story-progress]');
      if (!rail || !progress || !fill) return;

      section.dataset.coreProgressReady = 'true';
      let frame = 0;
      let touchStartX = null;
      let wrapArmed = false;
      const update = () => {
        const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const scrollRatio = maxScroll > 0 ? Math.min(1, Math.max(0, rail.scrollLeft / maxScroll)) : 0;
        const initialRatio = rail.scrollWidth > 0 ? Math.min(1, rail.clientWidth / rail.scrollWidth) : 1;
        const value = Math.min(1, initialRatio + scrollRatio * (1 - initialRatio));
        fill.style.transform = 'scaleX(' + value + ')';
        progress.setAttribute('aria-valuenow', String(Math.round(value * 100)));
      };
      const requestUpdate = () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          frame = 0;
          update();
        });
      };

      const mobileQuery = window.matchMedia('(max-width: 767px)');
      const isAtEnd = () => {
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        return maximum > 1 && rail.scrollLeft >= maximum - 2;
      };
      const onTouchStart = (event) => {
        if (!mobileQuery.matches || !event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        wrapArmed = isAtEnd();
      };
      const onTouchEnd = (event) => {
        if (!mobileQuery.matches || touchStartX === null) return;
        const changedTouch = event.changedTouches && event.changedTouches[0];
        const endX = changedTouch ? changedTouch.clientX : touchStartX;
        const shouldWrap = wrapArmed && touchStartX - endX > 36;
        touchStartX = null;
        wrapArmed = false;
        if (shouldWrap) {
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          rail.scrollTo({ left: 0, behavior });
        }
      };
      const onTouchCancel = () => {
        touchStartX = null;
        wrapArmed = false;
      };

      rail.addEventListener('scroll', requestUpdate, { passive: true });
      rail.addEventListener('touchstart', onTouchStart, { passive: true });
      rail.addEventListener('touchend', onTouchEnd, { passive: true });
      rail.addEventListener('touchcancel', onTouchCancel, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      requestAnimationFrame(update);
    });
  }

  function initializeCoreCta(root) {
    root.querySelectorAll('.sd-core-story__cta:not([data-core-ready])').forEach((cta) => {
      cta.dataset.coreReady = 'true';
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (cta.getBoundingClientRect().top < window.innerHeight) return;
      cta.setAttribute('data-core-waiting', '');
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          cta.removeAttribute('data-core-waiting');
          observer.disconnect();
        }
      }, { threshold: 0.25 });
      observer.observe(cta);
    });
  }
  initializeCoreCta(document);
  initializeCoreProgress(document);
  document.addEventListener('shopify:section:load', (event) => {
    initializeCoreCta(event.target);
    initializeCoreProgress(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
